// libraries
import { createSelector } from 'reselect';

export const selectModal = (state: any): any => state.modal;

export const selectModalTitle = createSelector(selectModal, ({ title }): string => title);

export const selectModalData = createSelector(selectModal, ({ data }): any => data);
